export default "__VITE_ASSET__WLm4agwM__"